const normalizeStreamUrl = (value) => {
    if (!value || typeof value !== 'string') return null;
    return value.startsWith('//') ? `https:${value}` : value;
};

export const normalizeKodikStreams = (links) => {
    const entries = Array.isArray(links)
        ? links.map((source) => [source?.quality, [source]])
        : Object.entries(links || {});

    return entries
        .flatMap(([quality, sources]) => (Array.isArray(sources) ? sources : []).map((source) => ({
            quality: String(source?.quality ?? quality ?? '').replace(/p$/i, ''),
            src: normalizeStreamUrl(source?.src || source?.url),
            type: source?.type || 'application/x-mpegURL',
        })))
        .filter((source) => source.quality)
        .filter((source) => source.src?.startsWith('https://'))
        .sort((left, right) => Number(left.quality) - Number(right.quality));
};

export const getKodikStreams = async (playerUrl, providedStreams) => {
    const normalizedProvidedStreams = normalizeKodikStreams(providedStreams);
    if (normalizedProvidedStreams.length) return normalizedProvidedStreams;

    const { VideoLinks } = await import('kodikwrapper');
    const links = await VideoLinks.getLinks({ link: playerUrl });
    return normalizeKodikStreams(links);
};

export const selectKodikStream = (streams, preferredQuality) => {
    if (!streams.length) return null;
    return streams.find((stream) => stream.quality === String(preferredQuality || '').replace(/p$/i, ''))
        || streams[streams.length - 1];
};
